// src/routes/StorekeeperRoutes.js
import ContainersPage from '../modules/Storekeeper/ContainersPage/ContainersPage';
import AuthRoute from '../modules/Base/Auth/components/AuthRoute';
import Home from '../modules/Storekeeper/index.jsx';
const StorekeeperRoutes = [
  {path: '/storekeeper', element: (<AuthRoute requiredPermissions={['pages:storekeeper:view:any']}><Home /></AuthRoute>),},
  {path: '/storekeeper/containers',element: (<AuthRoute requiredPermissions={['pages:manager:view:any']}><ContainersPage /></AuthRoute>),},
];

export default StorekeeperRoutes;
